import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";
import { v4 as uuidv4 } from "uuid";

class PinManager extends RESTDataSource {
  baseURL = config.api.vcmsURL;

  constructor(options) {
    super(options);
    this.context = options;
  }

  willSendRequest(_path, request) {
    if (this.context.req?.userToken) {
      const { id, accessToken } = this.context.req.userToken;
      request.headers["X-Token-Id"] = id;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Session-Request-Id"] = requestId;
    const userId = request.headers["X-User-Id"];
    console.log(
      `[${requestId}][Session][REQUEST INFO] Method: ${request.method}, Path: ${_path}, UserId: ${userId}`
    );
  }

  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Session-Request-Id"];
    console.log(
      `[${requestId}][Session][RESPONSE INFO] Status: ${response.status}`
    );
    return super.didReceiveResponse(response, request);
  }

  async pinActivate(code) {
    // TVデバイスのアクティベーションコードの認証
    const params = {
      pin_code: code,
    };
    return this.post("/pin/activate", { body: params });
  }
}

export default PinManager;
